// extracted by mini-css-extract-plugin
module.exports = {"pageContentTitle":"PageContentTitle_pageContentTitle__cP3fs"};